import { Mutation, SubmitApplicationResult } from '@varo/graphql-schema-types';
import SubmitBankApplication from 'services/graphql/mutations/SubmitBankApplication';
import { useMutation } from 'urql';

interface UseSubmitApplicationResult {
  submitApplication: (
    idempotencyId: string,
    agreements: string[],
    applicationId: string,
  ) => Promise<SubmitApplicationResult | Error>;
  submitApplicationResult: {
    data?: SubmitApplicationResult;
    error?: Error;
    fetching: boolean;
  };
}

export const useSubmitApplication = (): UseSubmitApplicationResult => {
  const [{ data, error, fetching }, executeMutation] = useMutation<Mutation>(
    SubmitBankApplication,
  );

  const submitApplication = async (
    idempotencyId: string,
    agreements: string[],
    applicationId: string,
  ): Promise<SubmitApplicationResult | Error> => {
    try {
      const result = await executeMutation({
        idempotencyId,
        agreements,
        applicationId,
      });
      if (result.error) {
        throw result.error;
      }
      return result.data?.submitApplication as SubmitApplicationResult;
    } catch (error) {
      return error as Error;
    }
  };

  return {
    submitApplication,
    submitApplicationResult: {
      data: data?.submitApplication,
      error,
      fetching,
    },
  };
};
